import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        default: 'bg-[var(--bg-elevated-2)] text-[var(--text-secondary)]',
        success: 'bg-[var(--success-muted)] text-[var(--success)]',
        error: 'bg-[var(--error-muted)] text-[var(--error)]',
        warning: 'bg-[var(--warning-muted)] text-[var(--warning)]',
        info: 'bg-[var(--info-muted)] text-[var(--info)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
